import React, { useState, useEffect, useCallback } from 'react'
import { connect } from 'react-redux'
import get from 'lodash/get'
import debounce from 'lodash/debounce'
import isEmpty from 'lodash/isEmpty'
import Modal, { ModalBody } from 'discada/dist/Modal'

import { addToPageState, removeFromPageState } from 'actions/pageStateActions'
import { hydrateCustomer } from 'actions/appStatusActions'
import { refreshPrograms, changeCurrentQuote } from 'actions/programActions'

import {
  getQueryValue,
  getActiveQuery,
  getActiveParams,
  getParamValue,
} from 'selectors/pageStateSelectors'

import {
  getCustomer,
  getRooftopName,
  getProfileOk,
  shouldShowDistractor,
  getIsKnownCustomerFromState,
  getCustomerVerifications,
  areProgramsDirty,
} from 'selectors/appStatusSelectors'

import { getQuoteDirty } from 'selectors/quoteSelectors'

import { ReactionForm, JACKET_STEPS, SQUEEZE_TIMER } from '.'

import './ReactionModal.scss'

import { getCustomerTrades } from 'selectors/naughtySelectors'
import { areTradesConfirmed } from 'utils/trade'

export function SqueezeModal({
  reaction = 'getOTD',
  step,
  isLoggedIn,
  addToPageState,
  removeFromPageState,
  customer = {},
  verifications = {},
  profileOk,
  query,
  showDistractor,
  tradesConfirmed,
  dirty,
  refreshPrograms,
}) {
  let [squeezeOk, setSqueezeOk] = useState(),
    [modalOpen, setModalOpen] = useState(),
    close = () => {
      dirty
        ? refreshPrograms({ showDistractor: true })
        : removeFromPageState(['reaction', 'step'])
    },
    setQuery = useCallback(debounce(addToPageState, 1000)),
    getStep = useCallback(() => {
      let idx = Math.max(
          0,
          JACKET_STEPS.findIndex(js => !verifications[js.step]),
        ),
        newStep = get(JACKET_STEPS[idx], 'step')

      // if a step is known already, use that
      return step || newStep || 'contact'
    }, [verifications, step]) //eslint-disable-line,

  // ----------
  // don't double up on modal opens,TODO hit myself
  useEffect(() => {
    setModalOpen(
      Object.keys(query).some(k =>
        [
          'showInventoryFilters',
          'quoteAction',
          'filterGroup',
          'changeZip',
          'showFandI',
          'addRebate',
          'contractDetails',
          'disclaimer',
          'distractor',
        ].includes(k),
      ), // TODO move to a const or something
    )
  }, [query])
  // ----------
  // set squeezeOk on timer to check for missing info missing info
  useEffect(() => {
    let squeezer = () => {
        let step = getStep(),
          shouldSqueeze =
            !modalOpen &&
            !squeezeOk &&
            !isLoggedIn &&
            !verifications.all &&
            !isEmpty(customer._entityType)

        shouldSqueeze && setQuery({ reaction, step })
      },
      squeezeCheck = !squeezeOk ? setTimeout(squeezer, SQUEEZE_TIMER) : null

    return () => squeezeCheck && clearTimeout(squeezeCheck)
  }, [
    squeezeOk,
    reaction,
    setQuery,
    getStep,
    modalOpen,
    squeezeOk,
    isLoggedIn,
    verifications.all,
    customer._entityType,
  ]) //eslint-disable-line
  // ----------
  // auto pop the modal at the trade step when trade not confirmed
  useEffect(() => {
    let modalNotOpen = !modalOpen && !squeezeOk

    if (modalNotOpen && !tradesConfirmed) {
      setQuery({ reaction, step: 'trades' })
    }
  }, [modalOpen, squeezeOk, tradesConfirmed, reaction, setQuery])
  // ----------
  // if there are new programs being got, show the jacket at the distractor step
  useEffect(() => {
    if (showDistractor && step !== 'getPayments') {
      setQuery({ reaction, step: 'getPayments' })
      window.scrollTo(0, 0)
    }
  }, [showDistractor])
  // ----------
  // if page state includes a reaction and step, squeeze is ok
  useEffect(() => {
    setSqueezeOk(!!(reaction && step))
  }, [reaction, step])
  // ----------
  // tag lastSqueeze on first render
  useEffect(() => {
    hydrateCustomer({
      lastSqueeze: new Date().getTime(),
    })
  }, []) //eslint-disable-line
  // ----------

  if (!profileOk || isLoggedIn || modalOpen) return null

  return squeezeOk ? (
    <Modal
      xnoClose
      autoHeight
      onClose={close}
      noClose={!tradesConfirmed}
      className="reaction-form-modal no-padding"
    >
      <ModalBody>
        <ReactionForm reaction={reaction} step={step} close={close} />
      </ModalBody>
    </Modal>
  ) : null
}

function mapStateToProps(state, op) {
  let customer = getCustomer(state),
    vehicleId = getParamValue(state, 'id'),
    quoteId = getQueryValue(state, 'quoteId'),
    query = getActiveQuery(state),
    params = getActiveParams(state),
    hasTrades = getCustomerTrades(state).length

  return {
    ...op,
    customer,
    query,
    params,
    hasTrades,
    reaction: getQueryValue(state, 'reaction'),
    step: getQueryValue(state, 'step'),
    rooftopName: getRooftopName(state),
    isVDP: vehicleId && quoteId,
    formState: { customer },
    isKnownCustomer: getIsKnownCustomerFromState(state),
    verifications: getCustomerVerifications(state),
    profileOk: getProfileOk(state),
    showDistractor: shouldShowDistractor(state),
    isQuoteDirty: getQuoteDirty(state, vehicleId, quoteId),
    tradesConfirmed: areTradesConfirmed(state),
    dirty: areProgramsDirty(state, vehicleId, quoteId),
  }
}

export default connect(
  mapStateToProps,
  {
    addToPageState,
    removeFromPageState,
    hydrateCustomer,
    refreshPrograms,
    changeCurrentQuote,
  },
)(SqueezeModal)
